/**
 * The ONE place the public API and MCP counts are written (owner rule: public counts are multiples of 50 with a plus).
 * shared/siteFacts.ts re-exports these for the site copy; generate-openapi.mjs uses them for the OpenAPI info block and the Postman
 * collection text. llms.txt, client/index.html, the MCP README, the newsletter data and docs/mcp-registry/utility-tools.server.json
 * are plain files; shared/siteFacts.publicCounts.test.ts fails when any of them disagrees with this file.
 * Floor only: the real numbers are higher. Raise to 250+ only when both really pass 250.
 */
export const API_COUNT_LABEL = "200+";
export const MCP_COUNT_LABEL = "200+";
